<!--
2021-11-03 CHP 增加 hideTopBar 和 hideFooter
-->
<template>
  <div id="app">
    <TopBar v-if="!$route.meta.hideTopBar"/>
    <div id="viewContainer">
      <GameIframe v-if="$store.state.gameInfo.showIframe"/>
      <div v-show="!$store.state.gameInfo.showIframe">
        <keep-alive v-if="$route.meta.keepAlive" key="keepAlive">
          <router-view/>
        </keep-alive>
        <router-view v-else key="refresh"/>
      </div>
      <Footer v-if="!$route.meta.hideFooter"/>
    </div>
    <Winner v-if="$store.state.showWinner" />
    <div id="support" class="pointer" @click="handleOpenChat">
      <img :src="support" alt="">
      {{ $t('lang.menu.Support') }}
    </div>
  </div>
</template>

<script>
import TopBar from './components/TopBar/index'
import Footer from './components/Footer/index'
import Winner from './components/Winner/index'
import GameIframe from './components/GameIframe/index'
import support from './assets/images/common/support.svg'
export default {
  name: 'App',
  data () {
    return {
      support
    }
  },
  components: {TopBar, Footer, Winner, GameIframe},
  mounted () {
    localStorage.setItem('locale', 'EN')
  },
  methods: {
    handleOpenChat () {
      window.LiveChatWidget.call('maximize')
    }
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
input {
  background: none;
  outline:none;
  border: none;
}
@font-face {
  font-family: Roboto;//定义font的名字
  src: url(./assets/fonts/Roboto/Roboto-Regular.ttf);//把下载的字体文件引入进来
  /*src: url(./assets/fonts/Roboto/Roboto-Medium.ttf);//把下载的字体文件引入进来*/
}
@font-face {
  font-family: Roboto-Medium;//定义font的名字
  src: url(./assets/fonts/Roboto/Roboto-Medium.ttf);//把下载的字体文件引入进来
  /*src: url(./assets/fonts/Roboto/Roboto-Medium.ttf);//把下载的字体文件引入进来*/
}
#app {
  font-family: Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  /*min-width: 1440px;*/
  min-width: 100vw;
  overflow: auto;
  margin: 0 auto;
  color: #686868;
  display: flex;
  flex-direction: column;
  background-color: #1b1b1b;
  #viewContainer {
    flex: 1;
    overflow: auto;
  }
  #support {
    position: fixed;
    right: -115px;
    top: 75%;
    transform: translateY(-50%);
    padding: 17px 38px 17px 17px;
    display: flex;
    align-items: center;
    font-size: 20px;
    color: #FFE39B;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 67px 0 0 67px;
    transition: right .3s;
    &:hover {
      right: 0;
    }
    img {
      width: 39px;
      padding: 4px;
      background: #FFE39B;
      margin-right: 12px;
      border-radius: 50%;
    }
  }
  #loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.5);
    text-align: center;
    >div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      img {
        width: 70%;
      }
    }
  }
  .pointer {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue